/**
 * Resolve Supabase URL + anon key for Edge middleware and client bundles.
 * Supports monorepo root `.env` (EXPO_PUBLIC_*) and web `.env.local` (NEXT_PUBLIC_*).
 */
export function resolveSupabasePublicEnv(): { url: string; anonKey: string } | null {
  const url =
    process.env.NEXT_PUBLIC_SUPABASE_URL?.trim() ||
    process.env.EXPO_PUBLIC_SUPABASE_URL?.trim() ||
    "";
  const anonKey =
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY?.trim() ||
    process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY?.trim() ||
    "";
  if (!url || !anonKey) return null;
  return { url, anonKey };
}
